// library imports

// styles imports
import './LayoutElement.scss';

const PageWrapper = (props) => {
    return (
        <div className="page-wrapper">
            {props.children}
        </div>
    );
};

export default PageWrapper;